/* eslint-disable */

import React from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import green from 'material-ui/colors/green';
import { CircularProgress } from 'material-ui/Progress';
import Button from 'material-ui/Button';
import Card, { CardHeader, CardContent } from 'material-ui/Card';
import Typography from 'material-ui/Typography';
import red from 'material-ui/colors/red';

import CreateIcon from 'material-ui-icons/Create';

import windTurbinesIcon from "../../assets/images/icons/wind-turbines.png";
import usersIcon from "../../assets/images/icons/user-groups.png";
import factoryIcon from "../../assets/images/icon-map-factory-cotton.png";
import userIcon from "../../assets/images/icons/person.png";

import organizationIcon from '../../assets/images/icons/company.png';

import Grid from 'material-ui/Grid';
import { Row, Col } from 'react-flexbox-grid';
import { withRouter } from 'react-router';
import { translate } from "react-i18next";
import { capitalize } from "../../utils/text";
import { enums } from "../../enums/";

import List from 'material-ui/List/List';
import ListItem from 'material-ui/List/ListItem';
import ListItemText from 'material-ui/List/ListItemText';

import {
  getOrganizationStart,
  getOrganizationUsers
} from '../../actions'
import { checkUserIsAdmin } from '../../utils/user/checkAdmin/CheckAdmin';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'center',
    height: '100%'
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    position: 'relative',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  actions: {
    display: 'flex',
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    marginLeft: 'auto',
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
});

class Organization extends React.Component {

  static contextTypes = {
    router: PropTypes.func.isRequired
  };

  componentDidMount = async () => {

    if (this.props.isAuthenticated) {
      const { match: { params } } = this.props;
      await this.props.getOrganizationStart(params.organizationId, this.props.history)

    } else {
      this.props.history.push('/')
    }
  };

  renderUpdateButton(history) {
    const { classes, isAuthenticated, user, currentOrganization } = this.props;
    if (checkUserIsAdmin(isAuthenticated, user)) {
      return (
        <Button
          variant="fab"
          color="primary"
          aria-label="add"
          className={classes.button}
          style={{
            margin: 0,
            bottom: 'auto',
            right: 48,
            top: 85,
            left: 'auto',
            position: 'fixed',
          }}
          onClick={() => { this.props.history.push('/organizations/update/' + currentOrganization._id) }}
        >
          <CreateIcon />
        </Button>
      )
    } else return false;
  }

  render() {
    const { classes, currentOrganization, loading, t } = this.props;

    if (loading) {
      return (
        <div className={classes.root}>
          <CircularProgress size={24} className={classes.buttonProgress} />
        </div>

      );
    }

    let organizationPicture = organizationIcon;
    if (currentOrganization.pictureFileName) {
      organizationPicture = process.env.REACT_APP_API_URL + '/static/organizations/' + currentOrganization.pictureFileName;
    }

    let parentOrganizationText = currentOrganization.parentOrganization && currentOrganization.parentOrganization.name ? 'Customer of ' + currentOrganization.parentOrganization.name : ''

    if(currentOrganization.type === enums.OrganizationTypes.UTILITY) parentOrganizationText = "Utility"

    return (
      <div className={classes.root}>
        {this.renderUpdateButton()}
        <Grid container spacing={24}>
          <Grid item xs={12} md={6}>
            <Card className={classes.card}>
              <CardHeader
                avatar={<img src={organizationIcon} style={{ maxHeight: 20 }} />}
                title={"Organization"}
              />
              <CardContent>
                <div className={classes.wrapper}>
                  <div style={{ textAlign: "center" }}>
                    <img
                    src={organizationPicture}
                    style={{ height: 60, width: 60, borderRadius: "50%", border: "1px solid rgba(0, 0, 0, 0.54)" }}
                    onError={(e)=>{e.target.onerror = null; e.target.src = organizationIcon}} />
                  </div>
                  <List dense>

                    <ListItem style={{ textAlign: "center" }}>
                      <ListItemText
                        primary={ currentOrganization.name }
                        secondary={ parentOrganizationText }
                        style={{ textAlign: "center", paddingRight: 0 }}
                      />
                    </ListItem>

                    <ListItem style={{ marginTop: 20 }}>
                      <Grid item xs={12}>
                        <Row>
                          <Col
                            style={{ textAlign: "center", cursor: "pointer"}}
                            xs={4}
                            onClick={() => {
                              this.props.history.push("/organizations/read/"+ currentOrganization._id +"/users");
                            }}
                            >
                            <div><img src={usersIcon} style={{ maxHeight: 20 }} /></div>
                            <div>
                              <Typography color="inherit" variant="caption">
                                Users
                              </Typography>
                            </div>
                          </Col>

                          <Col
                            style={{ textAlign: "center", cursor: "pointer"}}
                            xs={4}
                            onClick={() => {
                              this.props.history.push("/organizations/read/"+ currentOrganization._id +"/consum");
                            }}
                            >
                            <div><img src={factoryIcon} style={{ maxHeight: 20 }} /></div>
                            <div>
                              <Typography color="inherit" variant="caption">
                                Consumption assets
                              </Typography>
                            </div>
                          </Col>

                          <Col
                            style={{ textAlign: "center", cursor: "pointer"}}
                            xs={4}
                            onClick={() => {
                              this.props.history.push("/organizations/read/"+ currentOrganization._id +"/prod");
                            }}
                            >
                            <div><img src={windTurbinesIcon} style={{ maxHeight: 20 }} /></div>
                            <div>
                              <Typography color="inherit" variant="caption">
                                Production assets
                              </Typography>
                            </div>
                          </Col>
                        </Row>
                      </Grid>
                    </ListItem>

                    {currentOrganization.type !== enums.OrganizationTypes.CUSTOMER ?
                      <ListItem>
                        <ListItemText
                          primary="Matching Type"
                          secondary={currentOrganization.matchingType && currentOrganization.matchingType.name ? currentOrganization.matchingType.name : 'Unknown'}
                        />
                      </ListItem> :
                      <div></div>}

                      {currentOrganization.type === enums.OrganizationTypes.UTILITY ?
                      <ListItem>
                        <ListItemText
                          primary="Blockchain Address"
                          secondary={currentOrganization.blockchainAddress}
                        />
                      </ListItem> :
                      <div></div>}

                  </List>
                </div>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card className={classes.card}>
              <CardHeader
                avatar={<img src={userIcon} style={{ maxHeight: 20 }} />}
                title={"Contact"}
              />
              <CardContent>
                <div className={classes.wrapper}>
                  <List dense>
                    <ListItem>
                      <ListItemText
                        primary={"Name"}
                        secondary={capitalize(currentOrganization.contactFirstName) + " " + capitalize(currentOrganization.contactLastName)}
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemText
                        primary={"Email"}
                        secondary={currentOrganization.contactEmail}
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemText
                        primary={"Phone number"}
                        secondary={currentOrganization.contactPhoneNumber}
                      />
                    </ListItem>
                  </List>
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>

    );
  }
}

Organization.contextTypes = {
  router: PropTypes.object
}
Organization.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({ organizationsReducer, router, loginReducer }) => {
  const { currentOrganization, loading, organizationProducingAssets, organizationConsumingAssets } = organizationsReducer;
  const { location } = router;
  const { isAuthenticated, username, user } = loginReducer;
  return { currentOrganization, loading, location, isAuthenticated, username, user };
};

const mapDispatchToProps = {
  getOrganizationStart,
  getOrganizationUsers
}

Organization = withStyles(styles, { name: 'Organization' })(Organization);
Organization = translate("translations")(Organization);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Organization))



// WEBPACK FOOTER //
// ./src/components/Organization/Organization.js